
export const addOwnerUrl = '/renewals/master-data/owners/add'
export const addCostCenterUrl = '/renewals/master-data/cost-centers/add'
export const credentialsUrl = '/renewals/settings/credentials'
export const bulkImportUrl = '/renewals/settings/bulk-import'